export const prepareDataSource = (event, entity) => {
  const {
    id,
    type,
    created,
    [`${entity}_id`]: entityId,
    ...eventExtraData
  } = event;
  const eventExtraDataKeys = Object.keys(eventExtraData);
  let extraData = null;

  const commonData = [
    {label: 'ID', value: id},
    ...(entityId ? [{label: `${entity} ID`, value: entityId}] : []),
    {label: 'Type', value: type},
    {label: 'Created At', value: created},
  ];

  if (eventExtraDataKeys.length > 0) {
    extraData = eventExtraDataKeys.map((key) => ({
      label: key
        .replace(/_/gi, ' ')
        .replace('id', 'ID')
        .replace('member', 'record'),
      value: eventExtraData[key],
    }));
  }

  return {commonData, extraData};
};
